import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { Checkbox, TextArea } from 'semantic-ui-react';
import { debounce } from 'lodash';
import * as uuid from 'uuid';

export default function MultipleValueTextareaSwitch(props) {
  const findReference = (val, key) => {
    return props.references.find((ref) => ref[key] == val);
  };

  const hasReference = (item) => {
    return (
      item.metadata &&
      typeof item.metadata.reference !== 'undefined' &&
      findReference(item.metadata.reference, 'value')
    );
  };

  const buildArrayOfValues = () => {
    return props.value.map((item, index) => {
      return {
        value: item,
        metadata: props.metadata[index],
      };
    });
  };

  const removeFirstDollar = (val) => {
    if (typeof val !== 'string') {
      return val;
    }

    return val.startsWith('$$') ? val.substring(1) : val;
  };

  const [checked, setChecked] = useState(false);
  const [arrayOfValues, setArrayOfValues] = useState(buildArrayOfValues());

  useEffect(() => {
    setArrayOfValues(buildArrayOfValues());
  }, [props.value, props.metadata]);

  const translatedFromValue = useMemo(() => {
    return arrayOfValues.map((item) => {
      item.value.value = removeFirstDollar(item.value.value);
      if (!hasReference(item)) {
        return item.value;
      }

      let reference = findReference(item.metadata.reference, 'value');

      if (!reference) {
        return item.value;
      }

      return { value: reference.templateName, id: item.id };
    });
  }, [arrayOfValues]);

  const [value, setValue] = useState(translatedFromValue);

  const textareaValue = useMemo(
    () => value.map((v) => v.value).join('\n'),
    [value],
  );
  const parentValue = (items) => {
    let [values, metadata] = [[], []];

    items.map((val) => {
      let reference = findReference(val.value, 'templateName');

      if (val.value.startsWith('$')) {
        val.value = `$${val.value}`;
      }
      if (reference) {
        val.value = !props.isHash ? reference.value : `$${reference.value}`;
      }

      metadata.push(reference ? { reference: reference.value } : {});
      values.push(val);
    });

    return { items: values, metadata: metadata };
  };

  const checkCallback = useCallback((e, data) => {
    setChecked(data.checked);
    if (data.checked) {
      setValue(translatedFromValue);
    }
  });

  const valueCallback = useCallback((e, data) => {
    let newValue = data.value.split('\n').map((val, index) => {
      return { value: val, id: value[index] ? value[index].id : uuid.v4() };
    });

    setValue(newValue);
    debounce(() => {
      props.onChange(parentValue(newValue));
    }, 500)();
  });

  return (
    <Fragment>
      <If condition={props.display}>
        <div className='textareaSwitch'>
          <Checkbox
            toggle
            checked={checked}
            label='Edit using textarea'
            value='textarea'
            onChange={checkCallback}
          />
        </div>
      </If>
      <If condition={checked}>
        <TextArea
          style={{ height: `${length * 19}px`, minHeight: '230px' }}
          value={textareaValue}
          onChange={valueCallback}
        />
        <If condition={!props.isHash}>
          {arrayOfValues.map((val, index) => {
            return (
              <React.Fragment key={index}>
                <input
                  readOnly
                  name={hasReference(val) ? `${props.name}[value]` : props.name}
                  type='hidden'
                  value={
                    hasReference(val)
                      ? findReference(val.metadata.reference, 'value')
                          .templateName
                      : val.value.value
                  }
                />
                <If condition={hasReference(val)}>
                  <input
                    readOnly
                    name={`${props.name}[reference]`}
                    type='hidden'
                    value={val.metadata.reference}
                  />
                </If>
              </React.Fragment>
            );
          })}
        </If>
      </If>
      <If condition={!checked && props.children}>{props.children}</If>
    </Fragment>
  );
}
